"use strict";
/**
 * Compares to objects and returns `true` if the objects are deeply equal
 * (i.e. have an identical structure and values), or if they are
 * referentially equal. Because depo state values are immutable, two
 * referentially equal objects must be deeply equal, so internal iteration
 * can be avoided for increased run time.
 *
 * In practise this function is used to diff the previous and next versions
 * of mapped props data for a component, on store update, to avoid the triggering
 * of unnecessary render calls when the underlying data has not changed.
 *
 * Additionally, if a function is found within a provided object, it is
 * immediately skipped over, as this is expected to be an action that has
 * been mapped to props by the consumer, and will always be equal with the
 * next version of the data.
 *
 * @param a An object to compare
 * @param b An object to compare
 * @return A boolean indicating whether the objects are deeply of referentially equal.
 */
Object.defineProperty(exports, "__esModule", { value: true });
var isDeeplyOrReferentiallyEqual = function (a, b) {
    var aKeys = Object.keys(a);
    var bKeys = Object.keys(b);
    if (aKeys.length !== bKeys.length)
        return false;
    for (var _i = 0, aKeys_1 = aKeys; _i < aKeys_1.length; _i++) {
        var key = aKeys_1[_i];
        var aVal = a[key];
        var bVal = b[key];
        if (typeof aVal === 'function')
            continue;
        if (aVal &&
            typeof aVal === 'object' &&
            bVal &&
            typeof bVal === 'object' &&
            aVal !== bVal) {
            var isSubObjectDeepEqual = isDeeplyOrReferentiallyEqual(aVal, bVal);
            if (!isSubObjectDeepEqual)
                return false;
        }
        else {
            if (aVal !== bVal)
                return false;
        }
    }
    return true;
};
exports.default = isDeeplyOrReferentiallyEqual;
//# sourceMappingURL=isDeeplyOrReferentiallyEqual.js.map